import { AnyBlock } from "../types";
import { v4 as uuidv4 } from "uuid";

function cloneBlock(block: AnyBlock): AnyBlock {
  return {
    ...block,
    id: uuidv4(),
  };
}

export default cloneBlock;
